import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/feed",
    name: ROUTE_NAME.ANNOUNCEMENTS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.ANNOUNCEMENTS_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.ANNOUNCEMENTS_LIST,
        component: () => import("./views/AnnouncementListView.vue"),
      },
      {
        path: "new",
        name: ROUTE_NAME.ANNOUNCEMENT_COMPOSE,
        component: () => import("./views/AnnouncementComposeView.vue"),
      },
      {
        path: ":id/edit",
        name: ROUTE_NAME.ANNOUNCEMENT_EDIT,
        component: () => import("./views/AnnouncementComposeView.vue"),
        props: (route) => ({ postId: Number(route.params.id) }),
      },
    ],
  },
  // The tab was briefly Announcements; links shared from that week still land.
  {
    path: "/announcements/:rest(.*)?",
    redirect: (to) => ({
      path: `/feed${to.params.rest ? `/${to.params.rest}` : ""}`,
      query: to.query,
    }),
  },
];
